export default {
  screeningStatus(state) {
    return state.status;
  },
  screeningQuery(state) {
    return state.query;
  },
  screeningResult(state) {
    return state.result;
  },
  screeningDetails(state) {
    return state.details;
  },
  screeningError(state) {
    return state.error;
  },
  screeningHits(state, getters) {
    return getters.screeningResult;
  }
};
